module.exports = __webpack_public_path__ + "assets/70916b38587017c6f1d619f66c79448c.svg";